import { useFormContext } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import type { CreateSurveyFormValues } from '../../types/survey.types';
import { NumberField } from './primitives/NumberField';

interface QuestionRangeFieldsProps {
  questionIndex: number;
}

export function QuestionRangeFields({ questionIndex }: QuestionRangeFieldsProps) {
  const { control } = useFormContext<CreateSurveyFormValues>();

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <FormField
        control={control}
        name={`questions.${questionIndex}.minValue`}
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel>Min value</FormLabel>
            <FormControl>
              <NumberField
                value={field.value}
                onChange={field.onChange}
                aria-invalid={fieldState.invalid || undefined}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={`questions.${questionIndex}.maxValue`}
        render={({ field, fieldState }) => (
          <FormItem>
            <FormLabel>Max value</FormLabel>
            <FormControl>
              <NumberField
                value={field.value}
                onChange={field.onChange}
                aria-invalid={fieldState.invalid || undefined}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
